module.exports = __webpack_public_path__ + "img/sync-blue.e22d3252.svg";